import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import Styles from './TaskGroup.module.scss';
import { ReactComponent as Instagram } from '../../assets/svg/instagram.svg';
import { ReactComponent as Other } from '../../assets/svg/Group.svg';
import { ReactComponent as X } from '../../assets/svg/x.svg';
import { ReactComponent as Linkedin } from '../../assets/svg/linkedin.svg';
import { ReactComponent as Youtube } from '../../assets/svg/youtube.svg';
import { ReactComponent as Blog } from '../../assets/svg/blog.svg';
import { ReactComponent as CaseStudy } from '../../assets/svg/case-study.svg';
import { ReactComponent as Guide } from '../../assets/svg/Guide.svg';
import { ReactComponent as Quiz } from '../../assets/svg/quiz.svg';
import { ReactComponent as TikTok } from '../../assets/svg/tik-tok.svg';
import { ReactComponent as Facebook } from '../../assets/svg/facebook.svg';
import { ReactComponent as EmailNewsletter } from '../../assets/svg/email-newsletter.svg';

// Helper function to get the icon for a content type
const getContentTypeIcon = (contentType) => {
  const iconMap = {
    'Linkedin Post': <Linkedin />,
    'Linkedin Article': <Linkedin />,
    'Facebook Post': <Facebook />,
    'Instagram Carousel': <Instagram />,
    'Instagram Post': <Instagram />,
    'Instagram Reel': <Instagram />,
    'Twitter Thread': <X />,
    'Youtube Script': <Youtube />,
    'Email Newsletter': <EmailNewsletter />,
    'Blog Post': <Blog />,
    'Case Study': <CaseStudy />,
    'Guide': <Guide />,
    'Quiz': <Quiz />,
    'Tiktok Video': <TikTok />,
    'Medium Article': <Other />,
  };

  return iconMap[contentType] || null;
};

function TaskGroupHeader({ label, count, color, bgColor, isExpanded, onToggle, groupType = 'Status' }) {
  const contentTypeIcon = groupType === 'Content Type' ? getContentTypeIcon(label) : null;
  return (
    <button
      className={Styles.groupHeader}
      onClick={onToggle}
      aria-expanded={isExpanded}
      type="button"
    >
      <div className={Styles.groupHeaderLeft}>
        <FiChevronDown
          className={`${Styles.chevron} ${isExpanded ? Styles.chevronExpanded : ''}`}
          size={20}
        />
        <div className={Styles.groupLabelContainer}>
          <span className={Styles.groupTypeLabel}>{groupType}:</span>
          <span
            className={Styles.statusBadge}
            style={{
              color: color,
              backgroundColor: bgColor,
            }}
          >
            {contentTypeIcon && (
              <span className={Styles.contentTypeIcon}>
                {contentTypeIcon}
              </span>
            )}
            {label}
          </span>
        </div>
      </div>
      <span className={Styles.count}>
        {count} {count === 1 ? 'brief' : 'briefs'}
      </span>
    </button>
  );
}

export default TaskGroupHeader;
